/**
 * store / code.js
 * 
 * vue js code 목록들
 * 
 */


const state = {
  dashboardStats: {},           // 대시보드 통계
}

/**
 * 
 * 게터 - getters
 * 
 * 각 코드 목록을 label, value 형태로 변환하여 반환
 *
 * @returns {Object} 변환된 코드 목록
 */
const getters = {

}

/**
 * 
 * 뮤테이션 - mutations
 * 
 */
const mutations = {
  
}





/**
 * 
 * 액션 - actions
 * 
 */
const actions = {
  
}


// state, getters, mutations, actions, modules
export default {

  state: {
    ...state
  },
  getters,
  mutations,
  actions

}
